module.exports = __webpack_public_path__ + "img/logo_ibrvn.8f427f53.png";